import { Comment, CommentsPatch } from '../types'
import { isNonEmptyString } from './isEmptyString'
import { getMinimalValidComment } from './getMinimalValidComment'

type ReplyComment = Comment & { inReplyTo: string; stepId: undefined }

export const isReplyComment = (comment?: Comment): comment is ReplyComment => {
  return !!comment?.inReplyTo
}

type DirectStepComment = Comment & { inReplyTo?: undefined; stepId: string }

export const isDirectStepComment = (comment?: Comment): comment is DirectStepComment => {
  return !isReplyComment(comment) && !!comment?.stepId
}

type DirectIntentComment = Comment & { inReplyTo?: undefined; intentId: string }

export const isDirectIntentComment = (comment?: Comment): comment is DirectIntentComment => {
  return !isReplyComment(comment) && !!comment?.intentId
}

type DirectBotComment = Comment & { inReplyTo?: undefined; stepId: undefined }

export const isDirectBotComment = (comment?: Comment): comment is DirectBotComment => {
  return (
    !isReplyComment(comment) && !isDirectStepComment(comment) && !isDirectIntentComment(comment)
  )
}

type ResolvedComment = Comment & { status: 'resolved' }

export const isCommentResolved = (comment?: Comment): comment is ResolvedComment => {
  return comment?.status === 'resolved'
}

export const isTopLevelComment = (
  comment?: Comment
): comment is DirectStepComment | DirectBotComment => {
  return (
    isDirectIntentComment(comment) || isDirectStepComment(comment) || isDirectBotComment(comment)
  )
}

export const canCommentBeResolved = (comment?: Comment) => {
  return isTopLevelComment(comment) && !isCommentResolved(comment)
}

const isTextValidForSubmit = isNonEmptyString

export const isCommentValidForSubmitOnServer = (comment?: Comment) => {
  const hasValidText = !!comment?.text && isTextValidForSubmit(comment.text)
  return hasValidText && !!comment?.timestamp && !!comment.authorId && !!comment.id
}

if (!isCommentValidForSubmitOnServer(getMinimalValidComment())) {
  throw new Error('Minimal valid comment did not pass validation')
}

export const isPatchValidForSubmit = (patch: CommentsPatch) => {
  return isCommentValidForSubmitOnServer({
    ...getMinimalValidComment(),
    ...patch
  })
}
